import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { MedidoresUniverse } from '../../API/edicionMedidores/MedidoresUniverse.api';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import './SeleccionMeds.css'

//icons
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';//active
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';//inactive
import { GetDataUser } from '../../API/ALERTA/GetDataUser.api';
import { SaveSuscripcion } from '../../API/ALERTA/SaveSuscripcion.api';

export const SeleccionMeds = () => {

    let params = useParams();

    const [medidores, setMedidores] = useState([]);
    const [medidoresUser, setMedidoresUser] = useState([]);

    const [empresa, setEmpresa] = useState([]);
    const [selEmpresa, setSelEmpresa] = useState('');
    const [elemento, setElemento] = useState([]);
    const [selElemento, setSelElemento] = useState('');
    const [filterMed, setFilterMed] = useState([]);

    const [ValidUser, setValidUser] = useState(1);

    // busca los medidores y los campara con,os medidores seleccionados por el usuario para definir los ya seleccionados
    useEffect(() => {
        // console.log(params.token)
        const findUser = async () => {
            let userValid = await GetDataUser({token: params.token})
            // setMedidoresUser(userValid.body[0].MEDIDORES)

            let med = await MedidoresUniverse()
            await med.map(med_ => {
                med_["ISALERT"] = false
            })

            // console.log(med)
            
            for (let mdfnd = 0; mdfnd < userValid.body[0].MEDIDORES.length; mdfnd++) {
                const mdfnd_ = userValid.body[0].MEDIDORES[mdfnd];
                // console.log(mdfnd_._id)
                if(mdfnd_._id){
                    await med.map(med_ => {
                        if(mdfnd_._id === med_._id){
                            med_["ISALERT"] = true
                        }
                    })
                }
            }
            // console.log(med)

            setMedidores(med)
            var hash = {};
            let plt = await med.filter(function(current) 
            {
                let go = String(current.EMPRESA)
                let exists = !hash[go] || false;
                hash[go] = true;
                let emp = JSON.parse(exists)
                return exists;
            }).map(plt_ => plt_.EMPRESA)
            setEmpresa(plt)

            setValidUser(userValid.success? 3 : 2)
        }

        const getMedidores = async () => {
            let med = await MedidoresUniverse()
            // console.log(med)
            setMedidores(med)
            var hash = {};
            let plt = await med.filter(function(current) 
            {
                let go = String(current.EMPRESA)
                let exists = !hash[go] || false;
                hash[go] = true;
                let emp = JSON.parse(exists)
                return exists;
            }).map(plt_ => plt_.EMPRESA)
            setEmpresa(plt)
            // console.log(plt)
        }
        // getMedidores()
        findUser()
    }, [])

    useEffect(() => {
        const elemento = async () => {
            setSelElemento([]);
            let contratos = medidores.filter((med) => med.EMPRESA === selEmpresa)
            var hash = {};
            let plt = await contratos.filter(function(current) 
            {
                let go = String(current.ELEMENTO)
                let exists = !hash[go] || false;
                hash[go] = true;
                let emp = JSON.parse(exists)
                return exists;
            }).map(plt_ => plt_.ELEMENTO)
            let sorted_a = plt.sort((a, b) => a.localeCompare(b));
            setElemento(plt)
            // setMedidorChanged([])
            // console.log(sorted_a)
        }
        elemento()
    }, [selEmpresa])

    useEffect(() => {
        let fltMed = medidores.filter((med) => med.EMPRESA === selEmpresa && med.ELEMENTO === selElemento && med.SENSOR === "m1");
        // ordenar alfabeticamente los medidores
        let sorted_a = fltMed.sort((a, b) => a.MEDIDOR.localeCompare(b.MEDIDOR));
        setFilterMed(sorted_a);
        // setMedidorChanged([])
        // console.log(sorted_a)
        return () => {
            
        }
    }, [selElemento])

    const handleMedidorSelected = async (med,act) => {
        // console.log(med,act)
        let rs_med = await SaveSuscripcion({med, act, id:params.token})
        if(rs_med.success){
            let med_ = medidores.map(med_ => {
                if(med_._id === med._id){
                    med_["ISALERT"] = act === "add"? true : false
                }
                return med_
            })
            setMedidores(med_)
            let fltMed = medidores.filter((med) => med.EMPRESA === selEmpresa && med.ELEMENTO === selElemento && med.SENSOR === "m1");
            // ordenar alfabeticamente los medidores
            let sorted_a = fltMed.sort((a, b) => a.MEDIDOR.localeCompare(b.MEDIDOR));
            setFilterMed(sorted_a);
        }
    }
    
    // si el usuario es valido
    if(ValidUser===3){
        return (<>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <h1>Seleccion de Medidores</h1>
                    </div>
                </div>
            </div>

            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-md-6 mb-2'>
                        <FormControl fullWidth>
                            <InputLabel size='small' id="demo-simple-select-label">Empresa</InputLabel>
                            <Select
                                size='small'
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selEmpresa}
                                onChange={(e)=>setSelEmpresa(e.target.value)}
                                label="Empresa"
                            >
                            {
                                empresa?.map((emp, index) => <MenuItem key={index} value={emp}>{emp}</MenuItem>)
                            }
                            
                            </Select>
                        </FormControl>
                    </div>
                    <div className='col-12 col-md-6 mb-2'>
                        <FormControl fullWidth>
                            <InputLabel size='small' id="demo-simple-select-label">Elemento</InputLabel>
                            <Select
                                size='small'
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selElemento}
                                onChange={(e)=>setSelElemento(e.target.value)}
                                label="Elemento"
                            >
                            {
                                elemento?.map((emp, index) => <MenuItem key={index} value={emp}>{emp}</MenuItem>)
                            }
                            </Select>
                        </FormControl>
                    </div>
                    <div className='col-12 table-responsive-sm'>
                        <table className='table table-sm table-striped table-bordered'>
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col" className='text-center'><b>#</b></th>
                                    <th scope="col">Medidor</th>
                                    <th scope="col">Tipo</th>
                                    {/* <th  scope="col">Empresa</th> */}
                                    <th scope="col">Valor Alerta</th>
                                    <th scope="col">Alerta</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filterMed?.map((med, index) => 
                                        <tr key={index}>
                                            <td className='text-center'><b>{index+1}</b></td>
                                            <td>{med.FUENTE}</td>
                                            <td>{med.ELEMENTO}</td>
                                            {/* <td>{med.EMPRESA}</td> */}
                                            <td className='text-right'>{med.OPERACIONAL} <small>{med.UNIDAD}</small></td>
                                            <td className='text-center'>
                                                {
                                                    med.ISALERT?
                                                        <span className='click' onClick={()=>handleMedidorSelected(med, "delete")}><NotificationsActiveIcon color='success'/></span>
                                                        :
                                                        <span className='click' onClick={()=>handleMedidorSelected(med, "add")}><NotificationsOffIcon color='error'/></span>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        
                    </div>
                </div>
            </div>
        </>)
    }
    else if(ValidUser===1){// cargando
        return (<>
            <div className='d-flex justify-content-center align-items-center' style={{height: '100vh'}}>
                <div className=''>
                    <h1>Cargando...</h1>
                </div>
            </div>
        </>)
    }else{//si el usuario no es valido
        return (<>
            <div className='d-flex justify-content-center align-items-center' style={{height: '100vh'}}>
                <div className=''>
                    <h1>Usuario no valido</h1>
                </div>
            </div>
        </>)
    }
    
}
